import { StatusListToolPanel } from "../StatusListToolPanel";
import { Button, CityState, DataSource, Layout, Location, Panel, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStatusList extends Layout {
    buttonAddRecord: Button;
    citystateCons: CityState;
    citystateCurr: CityState;
    citystateShipper: CityState;
    layoutStatusListToolPanel: StatusListToolPanel;
    locationCons: Location;
    locationShipper: Location;
    locationStatusCity: Location;
    panelConsignee: Panel;
    panelSearch: Panel;
    panelShipper: Panel;
    panelStatusCity: Panel;
    searchpanelEdistatus: SearchPanel;
    sourceEdistatus: DataSource;
    switchBatchRange: Switch;
    switchSwitchError: Switch;
    switchSwitchIntercompany: Switch;
    switchSwitchIsResend: Switch;
    switchTransmitted: Switch;
    tableStatuses: Table;
    textboxBeginningBatch: Textbox;
    textboxCarrierId: Textbox;
    textboxConsAddress: Textbox;
    textboxConsLocId: Textbox;
    textboxConsLocName: Textbox;
    textboxCreateDate: Textbox;
    textboxCreateUserId: Textbox;
    textboxCurrAddress: Textbox;
    textboxCurrLocId: Textbox;
    textboxCurrLocName: Textbox;
    textboxCurrStopType: Textbox;
    textboxCustomerId: Textbox;
    textboxDelayCode: Textbox;
    textboxDirection: Textbox;
    textboxEdiBatchHistoryCreateDate: Textbox;
    textboxEdiBatchHistoryId: Textbox;
    textboxEdiBatchHistoryTransCount: Textbox;
    textboxEndingBatch: Textbox;
    textboxError: Textbox;
    textboxErrorDescr: Textbox;
    textboxOrderId: Textbox;
    textboxPartnerId: Textbox;
    textboxReadyToSend: Textbox;
    textboxSearchReferenceNumbers: Textbox;
    textboxShipAddress: Textbox;
    textboxShipLocId: Textbox;
    textboxShipLocName: Textbox;
    textboxStatusCode: Textbox;
    textboxUpdateDate: Textbox;
    textboxUpdateUserId: Textbox;
    textboxXmitSequence: Textbox;
}
